<template>
	<header-block v-if="customer" title="Achievements" bgcolor="white"></header-block>
	<CustomerLoadWait :customer="achievements" />
	<transition>
		<div v-if="achievements" class="notifications">
			<div class="notifications-list">
				
				<v-row v-for="a in achievements" :key="a.id" class="notificationRow">
					<v-col cols="1" class="iconCol">
						<img :src="require('@/assets/points.png')" class="icon" />
					</v-col>
					<v-col>
						<div class="notification-body">
							<p>{{ a.achievement.description}}</p>
						</div>
						<small>{{a.achievement.points}} point{{a.achievement.points > 1 ? 's' : ''}}.  {{ _csharpDateTimetoDateTime(a.achievementDateTime) }}</small>
					</v-col>
				</v-row>
					
			</div>

			<div v-if="hasOlderAchievements()" class="older-notifications-toggle">
				<a @click="showOlderAchievements = !showOlderAchievements" class="toggle-link">
					{{ showOlderAchievements ? 'Hide older achievements' : `Show ${getOlderAchievementsCount()} older achievements` }}
				</a>
			</div>

			<div class="ad">
				<h1>Stay in the loop</h1>
				<p>Make sure you have notifications enabled for the Money Guided app!</p>
				<small @click="$router.push('notifications')">Notification Settings</small>
			</div>
		</div>
	</transition>
	
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';

export default {
	mixins: [Services, Helpers],
	components: {CustomerLoadWait, HeaderBlock},
	data() {
		return {
			achievements: null,
			expandedAchievements: {},
			showOlderAchievements: false,
			daysToShow: 7
		}
	},
	computed: {
		// Remove all computed properties
	},
	methods: {
		hasOlderAchievements() {
			if (!this.achievements) return false;

			const daysFrom = new Date();
			daysFrom.setDate(daysFrom.getDate() - this.daysToShow);

			return this.achievements.some(a => new Date(a.achievementDateTime) < daysFrom);
		},
		getOlderAchievementsCount() {
			if (!this.achievements) return 0;

			const daysFrom = new Date();
			daysFrom.setDate(daysFrom.getDate() - this.daysToShow);

			return this.achievements.filter(a => new Date(a.achievementDateTime) < daysFrom).length;
		},
		onLoad: async function() {
			this._getCustomer(() => {
				this._getAchievements((achievements) => {
					this.achievements = achievements;
				});
			});
			
		},
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
.notifications {
	margin-top: -20px;
	margin-left: -30px;
	margin-right: -30px;
}

.notifications-list {
	position: relative;
	z-index: 1;
}

.older-notifications-toggle {
	text-align: center;
	padding-top: 15px;
}

.notifications {
	margin-top: -20px;
	margin-left: -30px;
	margin-right: -30px;
	span {
		float: right;
	}
	h2 {
		font-size: 16px;
	}
	.meta{
		font-weight: bold;
	}
	.notificationRow{
		padding: 5px 30px;
		border-bottom: 1px solid var(--border-color);
	}

	.notificationRow:last-child {
		border-bottom: none;
	}
	
	.iconCol {
		padding-right: 30px;
		padding-left: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.icon {
		width: 35px;
		border-radius: 50%;
		color: var(--background-color-alt2);
	}
	.opace {
		opacity: 0.5;
	}
	.ad{
		margin-top: 20px;
		background-color: var(--text-color);
		color: white;
		padding: 25px;
		h1{
			font-size: 20px;
		}
	}
}


.middleAlign {
	margin-top:auto;
	margin-bottom:auto;
}

.notification-body {
	position: relative;
}

.notification-body p {
	margin: 0;
	font-size: 14px;
	line-height: 1.4;
	overflow: hidden;
	transition: max-height 0.3s ease-in-out;
	max-height: 1000px; /* Default to expanded */
}

.notification-body p.truncated {
	max-height: 40px;
}

.notification-body p:not(.truncated) {
	max-height: 1000px;
}

.more-link {
	color: var(--text-color);
	text-decoration: underline;
	font-size: 12px;
	cursor: pointer;
	display: inline-block;
	margin-top: 4px;
}

.notification-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0;
	font-size: 16px;
	font-weight: bold;
}

.normal-weight {
	font-weight: normal;
}

.rightIcon {
	height: 10px;
	margin-top:auto;
	margin-bottom:auto;
	opacity: 0.5;
}

</style>
